import Cookies from 'js-cookie';

import CacheUtil from '@/assets/utils/CacheUtil';

// 暴露1
export function getToken() {
  return Cookies.get('system_token');
}

// 暴露2
export function removeToken() {
    Cookies.remove('system_token');
    Cookies.remove('_token');
    Cookies.remove('verify_token');
    Cookies.remove('tjk_login_token');
    Cookies.remove('login_token');
    Cookies.remove('merchant_token');
    Cookies.remove('taojintoken');

    // 一并移除
    CacheUtil.removeLocalStorageToken();

    return;
}


// WEBPACK FOOTER //
// ./src/assets/utils/AuthUtil.js